var map = {
	"./App": 71796,
	"./App.vue": 71796,
	"./assets/images/56-1/dot.png": 69400,
	"./assets/images/ESGstampNews/ESG.png": 14152,
	"./assets/images/ESGstampNews/affordableAndCleanEnergy.png": 99443,
	"./assets/images/ESGstampNews/cleanWaterAndSanitation.png": 81108,
	"./assets/images/ESGstampNews/climateAction.png": 28412,
	"./assets/images/ESGstampNews/decentWorkAndEconomicGrowth.png": 27782,
	"./assets/images/ESGstampNews/genderEquality.png": 12856,
	"./assets/images/ESGstampNews/goodHealthAndWellBeing.png": 84678,
	"./assets/images/ESGstampNews/industryInnovationAndInfrastructure.png": 57448,
	"./assets/images/ESGstampNews/lifeBelowWater.png": 71889,
	"./assets/images/ESGstampNews/lifeOnland.png": 65337,
	"./assets/images/ESGstampNews/noPoverty.png": 37059,
	"./assets/images/ESGstampNews/partnershipsForTheGoals.png": 4648,
	"./assets/images/ESGstampNews/peaceJusticeAndStrongInstitutions.png": 2851,
	"./assets/images/ESGstampNews/qualityEducation.png": 47784,
	"./assets/images/ESGstampNews/reducedInequalities.png": 71256,
	"./assets/images/ESGstampNews/responsibleConsumptionAndProduction.png": 3426,
	"./assets/images/ESGstampNews/sustainableCitiesAndCommunities.png": 37135,
	"./assets/images/ESGstampNews/zeroHunger.png": 96816,
	"./assets/images/ShareholderMeeting/bgDocumentMeetingNow.png": 91137,
	"./assets/images/ShareholderMeeting/bgMeetingNow.png": 30690,
	"./assets/images/annualReport/dot.png": 47368,
	"./assets/images/annualReport_56_1/Divider.png": 41934,
	"./assets/images/annualReport_56_1/dot.png": 70496,
	"./assets/images/annualReport_56_1/download.svg": 1861,
	"./assets/images/cacPage/contact.png": 21432,
	"./assets/images/cacPage/dot.png": 40973,
	"./assets/images/cacPage/lock.png": 97251,
	"./assets/images/cacPage/logoCAC.png": 86752,
	"./assets/images/cacPage/mail.png": 37955,
	"./assets/images/contactUs/L_gainfriends_2dbarcodes_BW.png": 37951,
	"./assets/images/contactUs/building.png": 99508,
	"./assets/images/contactUs/contact.png": 45050,
	"./assets/images/corporateGovernance/AGMscore1.png": 87397,
	"./assets/images/corporateGovernance/AGMscore2.png": 59566,
	"./assets/images/corporateGovernance/AGMscore3.png": 59063,
	"./assets/images/corporateGovernance/AGMscore4.png": 36920,
	"./assets/images/corporateGovernance/AGMscore5.png": 58049,
	"./assets/images/corporateGovernance/CAC_link.png": 99725,
	"./assets/images/corporateGovernance/CGscore1.png": 71466,
	"./assets/images/corporateGovernance/CGscore2.png": 2049,
	"./assets/images/corporateGovernance/CGscore3.png": 80920,
	"./assets/images/corporateGovernance/CGscore4.png": 13559,
	"./assets/images/corporateGovernance/CGscore5.png": 84334,
	"./assets/images/corporateGovernance/ESG_link.png": 11493,
	"./assets/images/corporateGovernance/build_inet.jpg": 48650,
	"./assets/images/corporateGovernance/dot.png": 33990,
	"./assets/images/corporateInformation/Trustworthy.png": 44468,
	"./assets/images/corporateInformation/energetic.png": 99979,
	"./assets/images/corporateInformation/inet_core_value_bg.png": 37383,
	"./assets/images/corporateInformation/inet_core_value_title.png": 35602,
	"./assets/images/corporateInformation/inet_mission_bg.png": 42682,
	"./assets/images/corporateInformation/inet_mission_line.png": 63333,
	"./assets/images/corporateInformation/inet_mission_title.png": 48273,
	"./assets/images/corporateInformation/innovation.png": 26962,
	"./assets/images/corporateInformation/neutral.png": 810,
	"./assets/images/corporateInformation/service.png": 20558,
	"./assets/images/corporateInformation/serviceAll.png": 57397,
	"./assets/images/corporateInformation/structure_1_eng.jpg": 57077,
	"./assets/images/corporateInformation/structure_1_th.jpg": 51889,
	"./assets/images/corporateInformation/structure_2_eng.jpg": 52922,
	"./assets/images/corporateInformation/structure_2_th.jpg": 40380,
	"./assets/images/dashboardPage/numberDashboard.png": 12182,
	"./assets/images/dividendPolicy/backgroundSection.jpg": 75172,
	"./assets/images/dividendPolicy/dot.png": 82924,
	"./assets/images/esgPage/Goal01.png": 69410,
	"./assets/images/esgPage/Goal02.png": 17593,
	"./assets/images/esgPage/Goal03.png": 20688,
	"./assets/images/esgPage/Goal04.png": 63535,
	"./assets/images/esgPage/Goal05.png": 24518,
	"./assets/images/esgPage/Goal06.png": 65757,
	"./assets/images/esgPage/Goal07.png": 44628,
	"./assets/images/esgPage/Goal08.png": 70547,
	"./assets/images/esgPage/Goal09.png": 31690,
	"./assets/images/esgPage/Goal10.png": 59264,
	"./assets/images/esgPage/Goal11.png": 14089,
	"./assets/images/esgPage/Goal12.png": 48946,
	"./assets/images/esgPage/Goal13.png": 97947,
	"./assets/images/esgPage/Goal14.png": 4356,
	"./assets/images/esgPage/Goal15.png": 30509,
	"./assets/images/esgPage/Goal16.png": 39830,
	"./assets/images/esgPage/Goal17.png": 17919,
	"./assets/images/esgPage/GoalLogo.png": 73894,
	"./assets/images/esgPage/dot.png": 62789,
	"./assets/images/esgPage/economy1.png": 18663,
	"./assets/images/esgPage/economy2.png": 67980,
	"./assets/images/esgPage/economy3.png": 79605,
	"./assets/images/esgPage/economy4.png": 11194,
	"./assets/images/esgPage/economy5.png": 17379,
	"./assets/images/esgPage/economy6.png": 39048,
	"./assets/images/esgPage/economy7.png": 87441,
	"./assets/images/esgPage/economyBackground.jpg": 28176,
	"./assets/images/esgPage/economyBackgroundNew.jpg": 3604,
	"./assets/images/esgPage/economyBackgroundNew_eng.jpg": 27925,
	"./assets/images/esgPage/economyBackgroundNew_th.jpg": 96401,
	"./assets/images/esgPage/economyText.png": 26337,
	"./assets/images/esgPage/economy_detail_eng.png": 23503,
	"./assets/images/esgPage/economy_detail_th.png": 90471,
	"./assets/images/esgPage/environment1.png": 4842,
	"./assets/images/esgPage/environment2.png": 53825,
	"./assets/images/esgPage/environment3.png": 69208,
	"./assets/images/esgPage/environment4.png": 60727,
	"./assets/images/esgPage/environmentBackground.jpg": 77719,
	"./assets/images/esgPage/environmentBackgroundNew.jpg": 9485,
	"./assets/images/esgPage/environmentBackgroundNew_eng.jpg": 3848,
	"./assets/images/esgPage/environmentBackgroundNew_th.jpg": 27414,
	"./assets/images/esgPage/environmentText.png": 58526,
	"./assets/images/esgPage/environment_detail_eng.png": 76090,
	"./assets/images/esgPage/environment_detail_th.png": 10892,
	"./assets/images/esgPage/society1.png": 87493,
	"./assets/images/esgPage/society10.png": 70081,
	"./assets/images/esgPage/society11.png": 97368,
	"./assets/images/esgPage/society2.png": 68718,
	"./assets/images/esgPage/society3.png": 58711,
	"./assets/images/esgPage/society4.png": 79096,
	"./assets/images/esgPage/society5.png": 51809,
	"./assets/images/esgPage/society6.png": 2826,
	"./assets/images/esgPage/society7.png": 53587,
	"./assets/images/esgPage/society8.png": 58292,
	"./assets/images/esgPage/society9.png": 79421,
	"./assets/images/esgPage/societyBackground.jpg": 51294,
	"./assets/images/esgPage/societyBackgroundNew.jpg": 53086,
	"./assets/images/esgPage/societyBackgroundNew_eng.jpg": 10715,
	"./assets/images/esgPage/societyBackgroundNew_th.jpg": 25883,
	"./assets/images/esgPage/societyText.png": 7755,
	"./assets/images/esgPage/society_detail_eng.png": 84397,
	"./assets/images/esgPage/society_detail_th.png": 85073,
	"./assets/images/esgPage/targetDimension_eng.png": 26124,
	"./assets/images/esgPage/targetDimension_th.png": 61426,
	"./assets/images/esgStructuredDataReport/dot.png": 64195,
	"./assets/images/financialInformation/FinancialStatement.jpg": 27699,
	"./assets/images/financialInformation/background.jpg": 21819,
	"./assets/images/financialInformation/dot.png": 17114,
	"./assets/images/inetW2/dot.png": 90066,
	"./assets/images/inetW2/imgTitleDetail.jpg": 91957,
	"./assets/images/loginAdmin/bgLoginAdmin.png": 10321,
	"./assets/images/loginAdmin/homeInvestorRelations_text.png": 73810,
	"./assets/images/loginAdmin/imgBgLogo.jpg": 57367,
	"./assets/images/loginAdmin/resetPassword.png": 5068,
	"./assets/images/logoInet.png": 20876,
	"./assets/images/managementTeam/dot.png": 47437,
	"./assets/images/mdAndA/MDandA.jpg": 48386,
	"./assets/images/mdAndA/background.jpg": 97469,
	"./assets/images/mdAndA/dot.png": 21136,
	"./assets/images/menu/DividendPolicyMenu.jpg": 12037,
	"./assets/images/menu/EN.png": 6826,
	"./assets/images/menu/TH.png": 9111,
	"./assets/images/menu/corporateInformation.png": 14866,
	"./assets/images/menu/corporateInformation_text.png": 74330,
	"./assets/images/menu/defaultBgMenu.png": 49936,
	"./assets/images/menu/homeInvestorRelations.png": 72915,
	"./assets/images/menu/homeInvestorRelations_text.png": 95801,
	"./assets/images/menu/homeInvestorRelations_text.svg": 37211,
	"./assets/images/menu/logo.png": 76942,
	"./assets/images/menuAdminAll/dashboardPage/viewPage.png": 88815,
	"./assets/images/news/news_1.jpg": 24126,
	"./assets/images/news/news_2.jpg": 50857,
	"./assets/images/news/news_icon.png": 63544,
	"./assets/images/presentationWebcast/bannerPresentationWebcast_eng.png": 62461,
	"./assets/images/presentationWebcast/bannerPresentationWebcast_th.png": 55009,
	"./assets/images/presentationWebcast/dot.png": 24092,
	"./assets/images/shareholdingStructure/ShareholderStructure_eng.png": 57120,
	"./assets/images/shareholdingStructure/ShareholderStructure_th.png": 23566,
	"./assets/images/shareholdingStructure/dot.png": 53766,
	"./assets/images/stockInformation/Factsheet.png": 6421,
	"./assets/images/testimg.jpg": 74574,
	"./assets/logo.png": 33153,
	"./assets/logo.svg": 63935,
	"./components/ESGstampNews": 20999,
	"./components/ESGstampNews.vue": 20999,
	"./components/MenuPage": 19984,
	"./components/MenuPage.vue": 19984,
	"./components/adminpage/detailManagementTeam": 72106,
	"./components/adminpage/detailManagementTeam.vue": 72106,
	"./components/adminpage/dialogLoading": 20315,
	"./components/adminpage/dialogLoading.vue": 20315,
	"./components/adminpage/formAnnounce/cardShowAnnounce": 74413,
	"./components/adminpage/formAnnounce/cardShowAnnounce.vue": 74413,
	"./components/adminpage/formAnnounce/formAddEditAnnounce": 23828,
	"./components/adminpage/formAnnounce/formAddEditAnnounce.vue": 23828,
	"./components/adminpage/formFile/formFileUpload": 26303,
	"./components/adminpage/formFile/formFileUpload.vue": 26303,
	"./components/adminpage/formFileDownloads/formAnnualReport": 57479,
	"./components/adminpage/formFileDownloads/formAnnualReport.vue": 57479,
	"./components/adminpage/formFileDownloads/formDescriptionDebentures": 45487,
	"./components/adminpage/formFileDownloads/formDescriptionDebentures.vue": 45487,
	"./components/adminpage/formFileDownloads/formDocumentsOfMeeting": 51079,
	"./components/adminpage/formFileDownloads/formDocumentsOfMeeting.vue": 51079,
	"./components/adminpage/formFileDownloads/formDocumentsOfMeetingSub": 92140,
	"./components/adminpage/formFileDownloads/formDocumentsOfMeetingSub.vue": 92140,
	"./components/adminpage/formFileDownloads/formEsgStructuredDataReport": 36816,
	"./components/adminpage/formFileDownloads/formEsgStructuredDataReport.vue": 36816,
	"./components/adminpage/formFileDownloads/formFinancialStatement": 2381,
	"./components/adminpage/formFileDownloads/formFinancialStatement.vue": 2381,
	"./components/adminpage/formFileDownloads/formForm56_1": 49368,
	"./components/adminpage/formFileDownloads/formForm56_1.vue": 49368,
	"./components/adminpage/formFileDownloads/formGovernancePolicy": 23884,
	"./components/adminpage/formFileDownloads/formGovernancePolicy.vue": 23884,
	"./components/adminpage/formFileDownloads/formMdAndA": 51330,
	"./components/adminpage/formFileDownloads/formMdAndA.vue": 51330,
	"./components/adminpage/formFileDownloads/formPresentationAndWebcast": 34056,
	"./components/adminpage/formFileDownloads/formPresentationAndWebcast.vue": 34056,
	"./components/adminpage/formFileDownloads/formSubscriptionRightsOfINETW2": 73830,
	"./components/adminpage/formFileDownloads/formSubscriptionRightsOfINETW2.vue": 73830,
	"./components/adminpage/formLogin/dialogForgetPassword": 43469,
	"./components/adminpage/formLogin/dialogForgetPassword.vue": 43469,
	"./components/adminpage/formNews/cardShowNews": 81302,
	"./components/adminpage/formNews/cardShowNews.vue": 81302,
	"./components/adminpage/formNews/formAddEditNews": 3268,
	"./components/adminpage/formNews/formAddEditNews.vue": 3268,
	"./components/adminpage/formTables/formDebentureInformation": 63159,
	"./components/adminpage/formTables/formDebentureInformation.vue": 63159,
	"./components/adminpage/formTables/formFinancialHighlights": 78491,
	"./components/adminpage/formTables/formFinancialHighlights.vue": 78491,
	"./components/adminpage/formTables/formFinancialRatios": 30993,
	"./components/adminpage/formTables/formFinancialRatios.vue": 30993,
	"./components/adminpage/formTables/formTheCompanyDividendPaymentInfo": 42337,
	"./components/adminpage/formTables/formTheCompanyDividendPaymentInfo.vue": 42337,
	"./components/adminpage/formTables/formTheFirstTop10Shareholders": 83490,
	"./components/adminpage/formTables/formTheFirstTop10Shareholders.vue": 83490,
	"./components/adminpage/formTeamPage/formAddPersionToTeam": 22149,
	"./components/adminpage/formTeamPage/formAddPersionToTeam.vue": 22149,
	"./components/adminpage/formTeamPage/formPersionTeam": 81173,
	"./components/adminpage/formTeamPage/formPersionTeam.vue": 81173,
	"./components/adminpage/formUserPage/formAddEditUser": 61030,
	"./components/adminpage/formUserPage/formAddEditUser.vue": 61030,
	"./components/adminpage/formUserPage/resetPassword": 4200,
	"./components/adminpage/formUserPage/resetPassword.vue": 4200,
	"./components/adminpage/formUserPage/resetPasswordOnEmail": 72916,
	"./components/adminpage/formUserPage/resetPasswordOnEmail.vue": 72916,
	"./components/adminpage/navigationAdminPage": 96867,
	"./components/adminpage/navigationAdminPage.vue": 96867,
	"./components/adminpage/selectDatePicker_th": 22453,
	"./components/adminpage/selectDatePicker_th.vue": 22453,
	"./components/adminpage/tableAll/tableAdminAll": 60503,
	"./components/adminpage/tableAll/tableAdminAll.vue": 60503,
	"./components/adminpage/tableAll/tableAdminPagination": 71896,
	"./components/adminpage/tableAll/tableAdminPagination.vue": 71896,
	"./components/adminpage/tableFileDownloadPage/tableAnnualReport": 30395,
	"./components/adminpage/tableFileDownloadPage/tableAnnualReport.vue": 30395,
	"./components/adminpage/tableFileDownloadPage/tableDescriptionDebentures": 80167,
	"./components/adminpage/tableFileDownloadPage/tableDescriptionDebentures.vue": 80167,
	"./components/adminpage/tableFileDownloadPage/tableDocumentsOfMeeting": 97652,
	"./components/adminpage/tableFileDownloadPage/tableDocumentsOfMeeting.vue": 97652,
	"./components/adminpage/tableFileDownloadPage/tableEsgStructuredDataReport": 81208,
	"./components/adminpage/tableFileDownloadPage/tableEsgStructuredDataReport.vue": 81208,
	"./components/adminpage/tableFileDownloadPage/tableFinancialStatement": 90138,
	"./components/adminpage/tableFileDownloadPage/tableFinancialStatement.vue": 90138,
	"./components/adminpage/tableFileDownloadPage/tableForm56_1": 22691,
	"./components/adminpage/tableFileDownloadPage/tableForm56_1.vue": 22691,
	"./components/adminpage/tableFileDownloadPage/tableGovernancePolicy": 14260,
	"./components/adminpage/tableFileDownloadPage/tableGovernancePolicy.vue": 14260,
	"./components/adminpage/tableFileDownloadPage/tableMdAndA": 21791,
	"./components/adminpage/tableFileDownloadPage/tableMdAndA.vue": 21791,
	"./components/adminpage/tableFileDownloadPage/tablePresentationAndWebcast": 35402,
	"./components/adminpage/tableFileDownloadPage/tablePresentationAndWebcast.vue": 35402,
	"./components/adminpage/tableFileDownloadPage/tableSubscriptionRightsOfINETW2": 22870,
	"./components/adminpage/tableFileDownloadPage/tableSubscriptionRightsOfINETW2.vue": 22870,
	"./components/adminpage/tablesTablePage/tableDebentureInformation": 14590,
	"./components/adminpage/tablesTablePage/tableDebentureInformation.vue": 14590,
	"./components/adminpage/tablesTablePage/tableFinancialHighlights": 75235,
	"./components/adminpage/tablesTablePage/tableFinancialHighlights.vue": 75235,
	"./components/adminpage/tablesTablePage/tableFinancialRatio": 2697,
	"./components/adminpage/tablesTablePage/tableFinancialRatio.vue": 2697,
	"./components/adminpage/tablesTablePage/tableTheCompanyDividendPaymentInfo": 76476,
	"./components/adminpage/tablesTablePage/tableTheCompanyDividendPaymentInfo.vue": 76476,
	"./components/adminpage/tablesTablePage/tableTheFirstTop10Shareholders": 71513,
	"./components/adminpage/tablesTablePage/tableTheFirstTop10Shareholders.vue": 71513,
	"./components/adminpage/titleHeaderMenu": 58538,
	"./components/adminpage/titleHeaderMenu.vue": 58538,
	"./components/adminpage/toolbarAdminPage": 43215,
	"./components/adminpage/toolbarAdminPage.vue": 43215,
	"./components/chart/lineChart": 77813,
	"./components/chart/lineChart.vue": 77813,
	"./components/chart/lineChartAdmin": 16821,
	"./components/chart/lineChartAdmin.vue": 16821,
	"./components/datepicker_th": 42960,
	"./components/datepicker_th.vue": 42960,
	"./components/esgNewsCategory": 70402,
	"./components/esgNewsCategory.vue": 70402,
	"./components/esgNewsDimension": 29124,
	"./components/esgNewsDimension.vue": 29124,
	"./components/footerHome": 26141,
	"./components/footerHome.vue": 26141,
	"./components/groupNews": 26660,
	"./components/groupNews.vue": 26660,
	"./components/loadingData": 48243,
	"./components/loadingData.vue": 48243,
	"./components/navigationDrawer": 7946,
	"./components/navigationDrawer.vue": 7946,
	"./components/table": 47965,
	"./components/table.vue": 47965,
	"./components/textEditer": 84872,
	"./components/textEditer.vue": 84872,
	"./components/toolbarHome": 89184,
	"./components/toolbarHome.vue": 89184,
	"./locale/en.ts": 25618,
	"./locale/th.ts": 43061,
	"./main": 58790,
	"./main.js": 58790,
	"./plugins/vuetify": 28294,
	"./plugins/vuetify.js": 28294,
	"./registerServiceWorker": 46177,
	"./registerServiceWorker.js": 46177,
	"./router": 58197,
	"./router/": 58197,
	"./router/index": 58197,
	"./router/index.js": 58197,
	"./scripts/eventbus": 67532,
	"./scripts/eventbus.js": 67532,
	"./scripts/mixin": 29565,
	"./scripts/mixin.js": 29565,
	"./store": 41153,
	"./store/": 41153,
	"./store/index": 41153,
	"./store/index.js": 41153,
	"./views/adminPage/adminPage": 68844,
	"./views/adminPage/adminPage.vue": 68844,
	"./views/adminPage/loginAdmin": 7541,
	"./views/adminPage/loginAdmin.vue": 7541,
	"./views/adminPage/menuAdmin/announcePage": 9508,
	"./views/adminPage/menuAdmin/announcePage.vue": 9508,
	"./views/adminPage/menuAdmin/dashboardPage": 84937,
	"./views/adminPage/menuAdmin/dashboardPage.vue": 84937,
	"./views/adminPage/menuAdmin/fileDownloadPage": 940,
	"./views/adminPage/menuAdmin/fileDownloadPage.vue": 940,
	"./views/adminPage/menuAdmin/filePage": 8439,
	"./views/adminPage/menuAdmin/filePage.vue": 8439,
	"./views/adminPage/menuAdmin/newsPage": 82780,
	"./views/adminPage/menuAdmin/newsPage.vue": 82780,
	"./views/adminPage/menuAdmin/tablePage": 7974,
	"./views/adminPage/menuAdmin/tablePage.vue": 7974,
	"./views/adminPage/menuAdmin/teamPage": 36344,
	"./views/adminPage/menuAdmin/teamPage.vue": 36344,
	"./views/adminPage/menuAdmin/teamPage/addPerson": 87812,
	"./views/adminPage/menuAdmin/teamPage/addPerson.vue": 87812,
	"./views/adminPage/menuAdmin/teamPage/sortPersonTeam": 66377,
	"./views/adminPage/menuAdmin/teamPage/sortPersonTeam.vue": 66377,
	"./views/adminPage/menuAdmin/userPage": 91759,
	"./views/adminPage/menuAdmin/userPage.vue": 91759,
	"./views/failPage": 39542,
	"./views/failPage.vue": 39542,
	"./views/homePage": 82772,
	"./views/homePage.vue": 82772,
	"./views/homePage/cardShowAnnounceToDay": 37409,
	"./views/homePage/cardShowAnnounceToDay.vue": 37409,
	"./views/homePage/contactPage": 90447,
	"./views/homePage/contactPage.vue": 90447,
	"./views/homePage/corporateGovernanceMain": 60110,
	"./views/homePage/corporateGovernanceMain.vue": 60110,
	"./views/homePage/corporateGovernanceMain/cacPage": 59058,
	"./views/homePage/corporateGovernanceMain/cacPage.vue": 59058,
	"./views/homePage/corporateGovernanceMain/corporateGovernance": 14158,
	"./views/homePage/corporateGovernanceMain/corporateGovernance.vue": 14158,
	"./views/homePage/corporateGovernanceMain/esgNews/economyNews": 15824,
	"./views/homePage/corporateGovernanceMain/esgNews/economyNews.vue": 15824,
	"./views/homePage/corporateGovernanceMain/esgNews/environmentNews": 65312,
	"./views/homePage/corporateGovernanceMain/esgNews/environmentNews.vue": 65312,
	"./views/homePage/corporateGovernanceMain/esgNews/societyNews": 47093,
	"./views/homePage/corporateGovernanceMain/esgNews/societyNews.vue": 47093,
	"./views/homePage/corporateGovernanceMain/esgPage": 92974,
	"./views/homePage/corporateGovernanceMain/esgPage.vue": 92974,
	"./views/homePage/corporateGovernanceMain/esgStructuredDataReportPage": 55235,
	"./views/homePage/corporateGovernanceMain/esgStructuredDataReportPage.vue": 55235,
	"./views/homePage/corporateOverview": 239,
	"./views/homePage/corporateOverview.vue": 239,
	"./views/homePage/corporateOverview/corporateInformation": 3691,
	"./views/homePage/corporateOverview/corporateInformation.vue": 3691,
	"./views/homePage/corporateOverview/managementTeam": 27605,
	"./views/homePage/corporateOverview/managementTeam.vue": 27605,
	"./views/homePage/debentureHolderInformation": 73108,
	"./views/homePage/debentureHolderInformation.vue": 73108,
	"./views/homePage/debentureHolderInformation/debentureInformation": 87697,
	"./views/homePage/debentureHolderInformation/debentureInformation.vue": 87697,
	"./views/homePage/debentureHolderInformation/debenturesOfInet": 30400,
	"./views/homePage/debentureHolderInformation/debenturesOfInet.vue": 30400,
	"./views/homePage/detailsNews": 55175,
	"./views/homePage/detailsNews.vue": 55175,
	"./views/homePage/financialInformationMain": 79389,
	"./views/homePage/financialInformationMain.vue": 79389,
	"./views/homePage/financialInformationMain/annualReport56-1/56_1OneReport": 76844,
	"./views/homePage/financialInformationMain/annualReport56-1/56_1OneReport.vue": 76844,
	"./views/homePage/financialInformationMain/annualReport56-1/annualReport": 15121,
	"./views/homePage/financialInformationMain/annualReport56-1/annualReport.vue": 15121,
	"./views/homePage/financialInformationMain/annualReport56-1/annualReport56_1": 74299,
	"./views/homePage/financialInformationMain/annualReport56-1/annualReport56_1.vue": 74299,
	"./views/homePage/financialInformationMain/annualReport56_1Main": 28341,
	"./views/homePage/financialInformationMain/annualReport56_1Main.vue": 28341,
	"./views/homePage/financialInformationMain/financialInformation": 53700,
	"./views/homePage/financialInformationMain/financialInformation.vue": 53700,
	"./views/homePage/financialInformationMain/mdAndA": 87202,
	"./views/homePage/financialInformationMain/mdAndA.vue": 87202,
	"./views/homePage/homeInvestorRelations": 7510,
	"./views/homePage/homeInvestorRelations.vue": 7510,
	"./views/homePage/newAllMain": 30793,
	"./views/homePage/newAllMain.vue": 30793,
	"./views/homePage/newAllMain/companyVisit": 59334,
	"./views/homePage/newAllMain/companyVisit.vue": 59334,
	"./views/homePage/newAllMain/newsAll": 17075,
	"./views/homePage/newAllMain/newsAll.vue": 17075,
	"./views/homePage/newAllMain/presentationWebcast": 7190,
	"./views/homePage/newAllMain/presentationWebcast.vue": 7190,
	"./views/homePage/shareholderInformation": 84455,
	"./views/homePage/shareholderInformation.vue": 84455,
	"./views/homePage/shareholderInformation/debenturesOfInet": 6573,
	"./views/homePage/shareholderInformation/debenturesOfInet.vue": 6573,
	"./views/homePage/shareholderInformation/dividendPolicy": 13958,
	"./views/homePage/shareholderInformation/dividendPolicy.vue": 13958,
	"./views/homePage/shareholderInformation/inetW2": 50410,
	"./views/homePage/shareholderInformation/inetW2.vue": 50410,
	"./views/homePage/shareholderInformation/shareholderMeeting": 53211,
	"./views/homePage/shareholderInformation/shareholderMeeting.vue": 53211,
	"./views/homePage/shareholderInformation/shareholdingStructure": 35859,
	"./views/homePage/shareholderInformation/shareholdingStructure.vue": 35859,
	"./views/homePage/shareholderInformation/stockInformation": 99446,
	"./views/homePage/shareholderInformation/stockInformation.vue": 99446,
	"./views/statsPage": 46041,
	"./views/statsPage.vue": 46041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;